import { isAnyOf } from '@reduxjs/toolkit'
import { changeActualsType, selectActualsType } from 'legacy/lut/features/partner360/configuration'
import { partnerDataFulfilled } from 'legacy/lut/features/partner360/configuration/partnerDataLifecycle'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import {
  selectCockpitMetric,
  selectCockpitMode,
  setCockpitMetric,
  setCockpitOffering,
} from '../model'
import { requestFinancialCockpitData } from '../model/thunks'

listenerMiddleware.startListening({
  matcher: isAnyOf(partnerDataFulfilled, requestFinancialCockpitData.fulfilled, setCockpitOffering),
  effect: (_, { dispatch, getState }) => {
    const state = getState()
    if (!selectCockpitMode(state)) {
      return
    }

    const metric = selectCockpitMetric(state)
    if (metric && selectActualsType(state) !== metric) {
      dispatch(changeActualsType(metric))
    }
  },
})

listenerMiddleware.startListening({
  actionCreator: changeActualsType,
  effect: (action, { dispatch, getState }) => {
    if (selectCockpitMetric(getState()) !== action.payload) {
      dispatch(setCockpitMetric(action.payload))
    }
  },
})

listenerMiddleware.startListening({
  actionCreator: setCockpitMetric,
  effect: (action, { dispatch, getState }) => {
    if (selectActualsType(getState()) !== action.payload) {
      dispatch(changeActualsType(action.payload))
    }
  },
})
